module.exports = __webpack_public_path__ + "static/media/Workday.64f651ef.svg";